<template>
  <form class="main-modal main-modal_w600" @submit.prevent="saveTag">
    <div class="main-modal__title">
      <p>
        <span v-if="!isUpdate">{{$t('forms.createTag')}}</span>
        <span v-else>{{$t('forms.updateTag')}}</span>
      </p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label">Tag</label>
      <input type="text" class="main-form__input" v-model="tag.name" :placeholder="'Tag'" />
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{$t('controls.tools')}}</label>

      <multiselect
        v-model="tag.instruments"
        :options="tools"
        :multiple="true"
        label="name"
        track-by="id"
        :placeholder="$t('controls.tools')"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{$t('controls.skills')}}</label>

      <multiselect
        v-model="tag.skills"
        :options="skills"
        :multiple="true"
        label="name"
        track-by="id"
        :placeholder="$t('controls.skills')"
      />
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{
        $t("global.cancel")
        }}
      </span>
      <button
        :disabled="!isValid"
        type="submit"
        class="main-button main-button_success"
      >{{ $t("global.save") }}</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'tagsModal',
    props: {
        isUpdate: {
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            tag: 'tags/tag',
            tools: 'tools/list',
            skills: 'skills/list',
        }),
        isValid() {
            if (this.tag.name === '' || this.tag.name === null) return false

            return !(this.tag.skills.length === 0 && this.tag.instruments.length === 0)
        },
    },
    methods: {
        ...mapMutations({
            setState: 'tags/setState',
        }),
        saveTag() {
            this.$emit('done')
        },
    },
    beforeDestroy() {
        this.setState({
            key: 'tag',
            data: {
                name: '',
                skills: [],
                instruments: [],
            },
        })
    },
}
</script>
